import axios from "axios";

function requestTablet2List(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/app/tablet/tablet2-page`,
    parameter.tablet2
  );
}

function registTablet2(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/app/tablet/regist/tablet2`,
    parameter.tablet2
  );
}
function requestTablet2Delete(id) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/app/tablet/delete/tablet2?id=${id}`
  );
}
export { requestTablet2List, registTablet2, requestTablet2Delete };
